import React from 'react';

import { Status as UIStatus } from '@gogame/components';

import { STATUS_ACTIVE, STATUS_INACTIVE } from 'scenes/Integrations/constants';

export const getColor = (id) => {
  switch (id) {
    case STATUS_ACTIVE:
      return 'success';
    case STATUS_INACTIVE:
      return 'inactive';
  }
};

export default ({ id, children }) => (
  <UIStatus color={getColor(id)}>{children}</UIStatus>
);
